/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Health10Inputs */

const en__field_enum_tuda_health10 = /** @type {(inputs: _Field_Enum_Tuda_Health10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health & Medicine`)
};

const de__field_enum_tuda_health10 = /** @type {(inputs: _Field_Enum_Tuda_Health10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheit & Medizin`)
};

/**
* | output |
* | --- |
* | "Health & Medicine" |
*
* @param {_Field_Enum_Tuda_Health10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_health10 = /** @type {((inputs?: _Field_Enum_Tuda_Health10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Health10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_health10(inputs)
	return de__field_enum_tuda_health10(inputs)
});
export { _field_enum_tuda_health10 as "_field_enum_TUDA_HEALTH" }